<template>
  <section v-if="content">
    <div class="grid-2-col">
      <div>
        <div class="label">{{ content.label }}</div>
        <h2>{{ content.title }}</h2>
        <div class="text" v-html="content.text"></div>
        <div class="btn">        
          <MainButton :buttonText="$t('button.details')" targetRoute="about" />
        </div>

      </div>
      <div class="image">
        <img src="img/person-working.webp" alt="it solutions" />
      </div>
    </div>
  </section>
</template>

<script>
import MainButton from '@/components/Buttons/MainButton.vue'

export default {
  name: 'AboutSection',
  components: {
    MainButton
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

